import React, { FC, ReactElement } from 'react'
import { Wrapper } from './ToolbarComponent.styles'

interface Props {
  children?: ReactElement
  align?: string
  className?: string
  darkBg?: boolean
  isCategory?: boolean
}

const ToolbarComponent: FC<Props> = ({ children, align, className, darkBg, isCategory }) => (
  <Wrapper
    align={align}
    className={className}
    darkBg={darkBg ? 'true' : 'false'}
    isCategory={isCategory ? 'true' : 'false'}
  >
    {children}
  </Wrapper>
)

export default ToolbarComponent
